"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.CarouselContext = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _clsx2 = _interopRequireDefault(require("clsx"));
var _styles = require("@material-ui/core/styles");
var _nukaCarousel = _interopRequireDefault(require("nuka-carousel"));
var _useMediaQuery = _interopRequireDefault(require("@material-ui/core/useMediaQuery"));
var _useBannerTracking3 = _interopRequireDefault(require("../_utils/useBannerTracking"));
var _CarouselNavButton = _interopRequireWildcard(require("./CarouselNavButton"));
var _CarouselPagination = _interopRequireDefault(require("./CarouselPagination"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) { if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } } return n.default = e, t && t.set(e, n), n; }
var __jsx = _react.default.createElement;
var useStyles = (0, _styles.makeStyles)(function (theme) {
  var _sliderControlCe3, _sliderControlCe4;
  return {
    wrapper: {
      '& .slider-control-centerleft': (0, _defineProperty2.default)({
        display: 'none'
      }, theme.breakpoints.up('md'), {
        display: 'block'
      }),
      '& .slider-control-centerright': (0, _defineProperty2.default)({
        display: 'none'
      }, theme.breakpoints.up('md'), {
        display: 'block'
      }),
      '& .slider-control-bottomcenter': (0, _defineProperty2.default)({
        bottom: '-40px !important'
      }, theme.breakpoints.up('md'), {
        bottom: '0px !important'
      }),
      // TODO: These styles were migrated out of global CSS
      // to provide a single source of truth. It's not clear where/how
      // they are used, but they should be removed if they aren't
      '& .slider-slide': {
        display: 'block !important'
      },
      '& div > div[data-cmp-hook-carousel="item"]': {
        cursor: 'default !important'
      },
      '& .slider-list .cmp-image__image': {
        marginBottom: '0px !important'
      },
      '& .slider-slide .cmp-image__image-item': {
        marginBottom: 0
      },
      '&$isEdit': {
        '& .slider-list': {
          position: 'relative',
          height: '488px',
          transform: 'none !important'
        },
        '& .slider-frame .slide': {
          left: '0 !important',
          position: 'absolute',
          visibility: 'hidden'
        },
        '& .slide-visible': {
          visibility: 'visible !important'
        }
      }
    },
    isEdit: {},
    fullWidth: {
      margin: '0 0 40px 0'
    },
    fullWidthAndHomePage: {
      '& .slider-frame': {
        width: '100vw !important',
        left: '50%',
        right: '50%',
        marginLeft: '-50vw !important',
        marginRight: '-50vw !important'
      },
      '& .slider-control-centerleft': (_sliderControlCe3 = {
        left: '20px !important'
      }, (0, _defineProperty2.default)(_sliderControlCe3, theme.breakpoints.up(theme.breakpoints.values.lg + 40), {
        left: '0 !important'
      }), (0, _defineProperty2.default)(_sliderControlCe3, theme.breakpoints.up(theme.breakpoints.values.lg + 160), {
        left: '-30px !important'
      }), _sliderControlCe3),
      '& .slider-control-centerright': (_sliderControlCe4 = {
        right: '20px !important'
      }, (0, _defineProperty2.default)(_sliderControlCe4, theme.breakpoints.up(theme.breakpoints.values.lg + 40), {
        right: '0 !important'
      }), (0, _defineProperty2.default)(_sliderControlCe4, theme.breakpoints.up(theme.breakpoints.values.lg + 160), {
        right: '-30px !important'
      }), _sliderControlCe4)
    },
    fullWidthNotHomePage: {
      '& .slider': {
        width: '100vw !important',
        left: '50%',
        right: '50%',
        marginLeft: '-50vw',
        marginRight: '-50vw'
      },
      '& .slider-control-centerleft': {
        left: '72px !important'
      },
      '& .slider-control-centerright': {
        right: '72px !important'
      }
    },
    title: {
      fontSize: theme.typography.pxToRem(26),
      fontWeight: theme.typography.fontWeightBold,
      color: theme.palette.primary.main,
      marginBottom: theme.spacing(5)
    },
    itemWrapper: {
      borderTop: "1px solid ".concat(theme.palette.grey[300]),
      paddingTop: theme.spacing(4)
    },
    itemTitle: {
      display: 'inline-block',
      fontSize: theme.typography.pxToRem(16),
      fontWeight: theme.typography.fontWeightMedium,
      marginBottom: theme.spacing(3)
    }
  };
});
var CarouselContext = /*#__PURE__*/_react.default.createContext(1);
exports.CarouselContext = CarouselContext;
var Carousel = function Carousel(_ref) {
  var _clsx;
  var children = _ref.children,
    shouldAutoplay = _ref.shouldAutoplay,
    autoplayInterval = _ref.autoplayInterval,
    shouldPauseOnHover = _ref.shouldPauseOnHover,
    cardsPerRotation = _ref.cardsPerRotation,
    isFullWidth = _ref.isFullWidth,
    hasPaginationDots = _ref.hasPaginationDots,
    shouldWrapAround = _ref.shouldWrapAround,
    isEdit = _ref.isEdit,
    isHomepage = _ref.isHomepage;
  var classes = useStyles();
  var theme = (0, _styles.useTheme)();
  var mediaQueryMdUp = (0, _useMediaQuery.default)(theme.breakpoints.up('md'));
  var _useBannerTracking = (0, _useBannerTracking3.default)('carousel', isHomepage),
    _useBannerTracking2 = (0, _slicedToArray2.default)(_useBannerTracking, 1),
    trackBannerClickEventGA = _useBannerTracking2[0];
  var _useState = (0, _react.useState)(1),
    activeSlide = _useState[0],
    setActiveSlide = _useState[1];
  var SlideToShowNumber = 1;
  if (mediaQueryMdUp) {
    SlideToShowNumber = cardsPerRotation;
  }
  var activeChildren = children.filter(function (component) {
    var _component$props$disa = component.props.disableOnPublisher,
      disableOnPublisher = _component$props$disa === void 0 ? false : _component$props$disa;
    return isEdit || !isEdit && !disableOnPublisher;
  });
  return __jsx(CarouselContext.Provider, {
    value: activeSlide
  }, __jsx("div", {
    className: (0, _clsx2.default)((_clsx = {
      'aem-ms-cmp aem-ms-carousel': true
    }, (0, _defineProperty2.default)(_clsx, classes.wrapper, true), (0, _defineProperty2.default)(_clsx, classes.fullWidth, isFullWidth), (0, _defineProperty2.default)(_clsx, classes.fullWidthAndHomePage, isFullWidth && isHomepage), (0, _defineProperty2.default)(_clsx, classes.fullWidthNotHomePage, isFullWidth && !isHomepage), (0, _defineProperty2.default)(_clsx, classes.isEdit, isEdit), _clsx))
  }, __jsx(_nukaCarousel.default, {
    slidesToShow: SlideToShowNumber,
    slidesToScroll: SlideToShowNumber,
    cellSpacing: 32,
    wrapAround: isHomepage ? true : shouldWrapAround,
    autoplay: shouldAutoplay,
    autoplayInterval: autoplayInterval,
    pauseOnHover: shouldPauseOnHover,
    renderAnnounceSlideMessage: function renderAnnounceSlideMessage(_ref2) {
      var currentSlide = _ref2.currentSlide,
        count = _ref2.count;
      return "Slide ".concat(currentSlide + 1, " of ").concat(count);
    },
    afterSlide: function afterSlide(index) {
      setActiveSlide(index + 1);
      trackBannerClickEventGA(index + 1);
    },
    renderCenterLeftControls: function renderCenterLeftControls(props) {
      var disabled = props.currentSlide === 0;
      var shouldRender = _react.default.Children.count(children) > SlideToShowNumber;
      return shouldRender && __jsx(_CarouselNavButton.default, {
        isHomepage: isHomepage,
        direction: _CarouselNavButton.CarouselNavButtonDirection.Previous,
        isDisabled: isHomepage ? false : disabled,
        isInsideContainer: isFullWidth,
        onClick: function onClick() {
          props.previousSlide();
        },
        isRound: hasPaginationDots
      });
    },
    renderBottomCenterControls: function renderBottomCenterControls(props) {
      var slidesPerPage = typeof props.slidesToScroll === 'number' ? props.slidesToScroll : parseInt(props.slidesToScroll, 10);
      return hasPaginationDots && __jsx(_CarouselPagination.default, {
        isHomepage: isHomepage,
        onPaginationItemClick: function onPaginationItemClick(index) {
          props.goToSlide(index);
        },
        currentSlide: props.currentSlide,
        slideCount: props.slideCount,
        slidesPerPage: slidesPerPage
      });
    },
    renderCenterRightControls: function renderCenterRightControls(props) {
      var disabled = props.currentSlide + props.slidesToShow === props.slideCount || props.slideCount < props.slidesToShow;
      var shouldRender = _react.default.Children.count(children) > SlideToShowNumber;
      return shouldRender && __jsx(_CarouselNavButton.default, {
        isHomepage: isHomepage,
        direction: _CarouselNavButton.CarouselNavButtonDirection.Next,
        isDisabled: isHomepage ? false : disabled,
        isInsideContainer: isFullWidth,
        onClick: function onClick() {
          props.nextSlide();
        },
        isRound: hasPaginationDots
      });
    }
  }, activeChildren)));
};
var _default = Carousel;
exports.default = _default;